import base from './environment.base';

export default {
  ...base,
  
  production: true,
  baseUrl: '',
  testPages: false,
  coreuiPages: false,
};
